<div class="posts {postsClass}">

    {#each limitedPosts as post, index (post.id)}

        <div class="posts__item">
    
            <div class="posts__item-content">

                <Post {...post} baseUrl={baseUrl} />

            </div>
        
        </div>    
    
    {/each}

    {#if limit > 0 && limit < posts.length}

    <div class="text text--align-center spacing spacing--padding-large">

        <Link to="/blog" button>Alle Beiträge</Link>

    </div>

    {/if}

</div>

<style>

    :global(.posts__item:nth-child(odd) .grid) {
        /* flex-direction: row-reverse; */
    }

    :global(.posts__item .grid) {
        flex-direction: row-reverse;
    }

    .posts {
        --thread-position: 5%;
        /* background-image: url(/img/dots.png);
        background-repeat: repeat-y;
        background-position: calc(var(--thread-position) - 6px) 0; */
        position: relative;
        /* margin: -4rem 0; */
        /* padding: 2rem 0; */
        overflow: hidden;
    }

    .posts__item {
        /* background-color: var(--white); */
        position: relative;
        margin: 8rem 0;
    }

    /* .posts__item::before {
        content: '';
        display: block;
        width: 2rem;
        height: 2rem;
        background-color: var(--light);
        border: 0.25rem solid var(--gray-400);
        border-radius: 2rem;
        position: absolute;
        top: 50%;
        left: var(--thread-position);
        transform: translate(-50%, -50%);
    } */

    .posts__item-content {
        background-color: var(--white);
        position: relative;
        /* border-bottom: 0.25rem solid var(--secondary); */
        /* padding-left: 1rem;
        padding-right: 1rem; */
        /* box-shadow: 0.25rem 0.25rem 0 var(--gray-400); */
        /* box-shadow: var(--box-shadow); */
    }

    /* .posts__item-content::before {
        content: '';
        display: block;
        width: 0;
        height: 0;
        border: 1rem solid transparent;
        border-right-color: var(--white);
        position: absolute;
        top: 50%;
        left: -2rem;
        transform: translate(0, -50%);
    } */

    @media screen and (min-width: 100rem) {
        .posts {
            --thread-position: calc((100% - var(--row-width)) * 0.25);
        }

        .posts__item-content {
            /* max-width: var(--row-width);
            margin-left: auto;
            margin-right: auto; */
            /* padding-left: 1rem;
            padding-right: 1rem; */
        }
    }

    .posts__item-options {
        position: absolute;
        left: 0;
        bottom: 0;
    }
	
</style>

<script>
    // components
    import Link from 'components/Link.html'
    import Post from 'components/Post.html'
    

	export default {
        components: {
            Link,
            Post
        },
        computed: {
            postsClass: ({ block }) => {
                let classes = []

                if (block) classes.push(`posts--block`)

                return classes.filter(Boolean).join(' ')
            },
            limitedPosts: ({ posts, limit }) => {
                return limit > 0 && limit < posts.length ? posts.slice(0, limit) : posts
            }
        },
        data() {
            return {
                posts: [],
                block: false,
                label: '',
                baseUrl: '/',
                limit: 0
            }
        }
	}
</script>